export default class OracleMapping {
  formatGetCustomerResponse(data: { identificadorContacto: string }): {
    partyId: string;
  } {
    return {
      partyId: data.identificadorContacto,
    };
  }
  formatGetOpportunityResponse(data: { numeroOportunidad: string }): {
    optyNumber: string;
  } {
    return {
      optyNumber: data.numeroOportunidad,
    };
  }
}
